"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultilineText = void 0;
const react_1 = __importDefault(require("react"));
const multiline_text_styles_1 = require("./multiline-text.styles");
const MultilineText = ({ maxRows, width, children, }) => (react_1.default.createElement(multiline_text_styles_1.StyledEllipsisContainer, { maxRows: maxRows, width: width }, react_1.default.createElement("p", null, children)));
exports.MultilineText = MultilineText;
MultilineText.displayName = 'MultilineText';
